module.exports = __webpack_public_path__ + "img/link.05560e61.svg";